import { async } from '@angular/core/testing';
import { Component, OnInit, TemplateRef, enableProdMode } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, FormsModule, Form } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SendTestProfileService } from '../send-test-profile.service';
import { SendTestProfile } from '../send-test-profile.model';
import { BsModalService, TimepickerModule } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Client } from '../../client/client.model';
import { UserIdentifier } from '../userIdentifier.model';

@Component({
  selector: 'app-sendtestprofile',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})

export class SendTestProfileFormComponent implements OnInit {
  sendTestProfileForm: FormGroup;
  campaignId: FormControl;
  aepTestProfile: FormControl;
  environment:FormControl;
  firstName: FormControl;
  lastName: FormControl;
  dob: FormControl;
  gender: FormControl;
  phoneWithCountrycode: FormControl;
  email:FormControl;
  userIdentifier:FormControl;
  userIdentifierType:FormControl;
  userIdentifierSubType: FormControl;
  addressLine1: FormControl;
  addressLine2: FormControl;
  addressCity: FormControl;
  addressState: FormControl;
  addressCountry: FormControl;
  addressPostalcode: FormControl;
  eventType: FormControl;
  eventSubType: FormControl;
  genderList: Array<string>;
  environmentList: Array<string>;
  userIdentifierTypeList: Array<string>;
  userIdentifierSubTypeList: Array<string>;
  showAlert = false;
  showSuccessAlert=false;
  errorMessage: string = null;
  successMessage: string = null;
  isEditing: boolean;
  ifEnvironmentRequire:boolean;
  client: Client;
  loading: boolean = false;
  apiKey: string;
  constructor(
    private router: Router,
    private sendTestProfileService: SendTestProfileService,
    private datePipe:DatePipe
  ) {}

  ngOnInit() {
    this.createFormControls();
    this.createForm();
    this.aepTestProfile.setValue(true);
    this.genderList = this.sendTestProfileService.getGenderList();
    this.environmentList=this.sendTestProfileService.getEnvironmentList();
    this.userIdentifierTypeList=this.sendTestProfileService.getUserIdentifierTypeList();
    this.userIdentifierSubTypeList=this.sendTestProfileService.getUserIdentifierSubTypeList();
    this.isEditing = false;
  }

  createFormControls() {
    this.campaignId = new FormControl('', {
      validators: Validators.required
    });
    this.aepTestProfile = new FormControl('', {
      validators: Validators.required
    });
    this.environment = new FormControl('', {
      validators: Validators.required
    });
    this.firstName = new FormControl('');
    this.lastName = new FormControl('');
    this.dob = new FormControl('');
    this.gender = new FormControl('');
    this.phoneWithCountrycode = new FormControl('',{
      validators:Validators.pattern(/^(\d{1,3})-(\d+)$/)
    });
    this.email=new FormControl('');
    this.addressLine1 = new FormControl('');
    this.addressLine2 = new FormControl('');
    this.addressCity = new FormControl('');
    this.addressState = new FormControl('');
    this.addressCountry = new FormControl('');
    this.addressPostalcode = new FormControl('');
    this.userIdentifier = new FormControl('');
    this.userIdentifierType = new FormControl('');
    this.userIdentifierSubType = new FormControl('');
    this.eventType = new FormControl('');
    this.eventSubType = new FormControl('');

  }

  createForm() {
    this.sendTestProfileForm = new FormGroup({
      campaignId: this.campaignId,
      aepTestProfile: this.aepTestProfile,
      environment:this.environment,
      firstName: this.firstName,
      lastName: this.lastName,
      dob: this.dob,
      gender: this.gender,
      phoneWithCountrycode: this.phoneWithCountrycode,
      email:this.email,
      userIdentifier: this.userIdentifier,
      userIdentifierType:this.userIdentifierType,
      userIdentifierSubType: this.userIdentifierSubType,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      addressCity: this.addressCity,
      addressState: this.addressState,
      addressCountry: this.addressCountry,
      addressPostalcode: this.addressPostalcode,
      eventType: this.eventType,
      eventSubType: this.eventSubType,
    });
  }

  getSendTestProfileFrom() {
    const profileData = new SendTestProfile();
    const userIdentifier=new UserIdentifier();
    const userIdentifiers=new Array<UserIdentifier>();
    profileData.aep_test_profile_environment=this.environment.value || null;
    profileData.campaign_id = this.campaignId.value || null;
    profileData.aep_test_profile = this.aepTestProfile.value || false;
    profileData.first_name = this.firstName.value || null;
    profileData.last_name = this.lastName.value || null;
    profileData.dob = this.dob.value || null;
    profileData.gender = this.gender.value || null;
    profileData.phone_with_countrycode = this.phoneWithCountrycode.value || null;
    profileData.email = this.email.value || null;
    profileData.address_line1 = this.addressLine1.value || null;
    profileData.address_line2 = this.addressLine2.value || null;
    profileData.address_city = this.addressCity.value || null;
    profileData.address_state = this.addressState.value || null;
    profileData.address_country = this.addressCountry.value || null;
    profileData.address_postalcode = this.addressPostalcode.value || null;
    profileData.event_type = this.eventType.value || null;
    profileData.event_sub_type = this.eventSubType.value || null;
    userIdentifier.user_identifier=this.userIdentifier.value || null;
    userIdentifier.user_identifier_type=this.userIdentifierType.value||null;
    userIdentifier.user_identifier_sub_type=this.userIdentifierSubType.value || null;
    userIdentifiers.push(userIdentifier);
    profileData.user_identifiers=userIdentifiers;
    return profileData;
  }

  sendTestProfileSubmit(template: TemplateRef<any>): any {
    this.dirtyForm(this.sendTestProfileForm);
    if (this.sendTestProfileForm.valid) {
      const postData = this.getSendTestProfileFrom();
      if(!postData.phone_with_countrycode&&!postData.email){
        this.errorMessage = "Please enter the Phone or Email";
        this.loading = false;
        this.showAlert = true;
        return;
      }
      if(postData.address_country){
        postData.address_country=postData.address_country.toLowerCase();
      }
      if(postData.dob){
        postData.dob=this.datePipe.transform(postData.dob,"dd/MM/yyyy");
      }

      this.ifEnvironmentRequire=false;
      console.log('profileData:'+JSON.stringify(postData));
      this.loading = true;
      this.sendTestProfileService.getClientById(postData.campaign_id)
      .subscribe((clients) => {
        if (clients[0]) {
          console.log(JSON.stringify(clients[0]))
          this.apiKey = clients[0].apiKey;
          this.client = clients[0];
          if (this.client&&this.client.clientId&&this.apiKey) {
            postData.client_id=this.client.clientId;
            this.sendTestProfileService.requestRealTime(postData,this.apiKey)
                .subscribe(res => {
                  this.loading = false;
                  this.showSuccessAlert=true;
                  this.successMessage="send successfully";
                  this.sendTestProfileForm.reset();
                  this.aepTestProfile.setValue(true);
                }, error => {
                  this.loading = false;
                  this.showAlert = true;
                  this.errorMessage = JSON.stringify(error);
                });
          }else{
            this.errorMessage = "Please enter correct Campaign ID and make sure it has the Client ID";
            this.loading = false;
            this.showAlert = true;
          }
        }else{
          this.errorMessage = "Please enter correct Campaign ID and make sure it has the Client ID";
          this.loading = false;
          this.showAlert = true;
        }
      });
    }
  }

  errorMessageClose(): void {
    this.showAlert = false;
    this.errorMessage = '';
  }

  successMessageClose(): void {
    this.showSuccessAlert = false;
    this.successMessage = '';
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() =>
        this.router.navigate([uri]));
  }

  private dirtyForm(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {
      const control = form.controls[key];

      if (control instanceof FormGroup) {
        return this.dirtyForm(control);
      }

      control.markAsDirty();
    });
  }

  checkHtml (htmlStr: string): boolean {
    let reg = /<[^>]+>/g;
    return reg.test(htmlStr);
  }

  checkInputNumberValue (e) {
    return this[e.target.id].value = e.target.value = e.target.value.replace(/[^0-9_\- ]||/g,'');
  }

  checkInputLetterValue (e) {
    return this[e.target.id].value = e.target.value = e.target.value.replace(/[^a-zA-Z]||/g,'');
  } 
}



// WEBPACK FOOTER //
// ./src/app/modules/send-test-profile/form/form.component.ts